/* eslint-disable functional/no-this-expressions */
import { Component, ReactNode } from 'react';
import { t } from '../../../i18next';
import { Button } from '@airbus/components-react';
import posthog from 'posthog-js';

type PropsType = {
  children: ReactNode;
  fallback: ReactNode;
};

type StateType = {
  hasError: boolean;
};

/* eslint-disable-next-line functional/no-classes, functional/no-class-inheritance */
export class CustomErrorBoundary extends Component<PropsType, StateType> {
  constructor(props: PropsType) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Example "componentStack":
    //   in ComponentThatThrows (created by App)
    //   in ErrorBoundary (created by App)
    //   in div (created by App)
    //   in App
    console.error(error, info.componentStack);
    posthog.captureException(error, info);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return this.props.fallback;
    }

    return this.props.children;
  }
}

export function ErrorFallback() {
  const handleReload = () => window?.location?.reload();

  return (
    <section>
      <p>{t('exception_occurred')}</p>
      <Button variant='primary' onClick={handleReload}>
        Reload Screen
      </Button>
    </section>
  );
}

export function withErrorBoundary(Component) {
  return function ComponentWithErrorBoundary(props) {
    return (
      <CustomErrorBoundary fallback={<ErrorFallback />}>
        <Component {...props} />
      </CustomErrorBoundary>
    );
  };
}
